// import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
// import {
//   Box, Grid, Card, CardContent, Typography, CircularProgress,
//   Chip, FormControl, InputLabel, Select, MenuItem,
// } from "@mui/material";
// import {
//   Inventory2, Scale, Science, WaterDrop, CheckCircle,
//   DoDisturbOn, Factory, Refresh,
// } from "@mui/icons-material";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale, LinearScale, BarElement,
//   Title, Tooltip, Legend,
// } from "chart.js";
// import axiosClient from "../../configs/axios";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // ─── Design tokens ────────────────────────────────────────────────────────────
// const C = {
//   navy: "#1B3A6B",
//   accent: "#2563EB",
//   bg: "#F0F4F8",
//   card: "#FFFFFF",
//   border: "#E2E8F0",
//   textMuted: "#64748B",
//   success: "#16A34A",
//   warn: "#D97706",
//   err: "#DC2626",
// };

// // Chart colours per spec
// const CHART_COLORS = {
//   production: "#2563EB",
//   cylinders: "#16A34A",
//   carbide: "#D97706",
//   acetone: "#DC2626",
// };

// const REFRESH_INTERVAL_MS = 60_000;

// // ─── KPI Card ─────────────────────────────────────────────────────────────────
// const KpiCard = ({ label, value, unit, icon: Icon, accentColor = C.accent, loading }) => (
//   <Card
//     elevation={0}
//     sx={{
//       border: `1px solid ${C.border}`,
//       borderRadius: "10px",
//       borderLeft: `3px solid ${accentColor}`,
//       background: C.card,
//       height: "100%",
//     }}
//   >
//     <CardContent sx={{ p: "12px 14px !important" }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//         <Box>
//           <Typography sx={{ fontSize: 10, color: C.textMuted, fontWeight: 500, letterSpacing: 0.4, textTransform: "uppercase", mb: 0.5 }}>
//             {label}
//           </Typography>
//           {loading ? (
//             <CircularProgress size={18} sx={{ color: accentColor, mt: 0.5 }} />
//           ) : (
//             <Typography sx={{ fontSize: 24, fontWeight: 700, color: C.navy, lineHeight: 1 }}>
//               {value ?? "—"}
//             </Typography>
//           )}
//           {unit && !loading && (
//             <Typography sx={{ fontSize: 11, color: C.textMuted, mt: 0.3 }}>{unit}</Typography>
//           )}
//         </Box>
//         <Icon sx={{ fontSize: 26, color: accentColor, opacity: 0.15, mt: 0.3 }} />
//       </Box>
//     </CardContent>
//   </Card>
// );

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// function getLast7Days() {
//   return Array.from({ length: 7 }, (_, i) => {
//     const d = new Date();
//     d.setDate(d.getDate() - (6 - i));
//     return d.toISOString().split("T")[0]; // YYYY-MM-DD
//   });
// }

// function formatDateLabel(iso) {
//   return new Date(iso).toLocaleDateString("en-IN", { month: "short", day: "numeric" });
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// const PlantDashboard = () => {
//   // ── User info ─────────────────────────────────────────────────────────────
//   const userInfo = useMemo(() => {
//     try {
//       const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
//       return d?.result?.userInfo || {};
//     } catch {
//       return {};
//     }
//   }, []);

//   const assignedPlantId = userInfo?.assigned_plant_id ?? "";

//   // ── State ─────────────────────────────────────────────────────────────────
//   const [plants, setPlants] = useState([]);
//   const [selectedPlantId, setSelectedPlantId] = useState(assignedPlantId ? String(assignedPlantId) : "");
//   const [productionData, setProductionData] = useState(null);
//   const [inventoryData, setInventoryData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [chartLoading, setChartLoading] = useState(false);
//   const [lastRefreshed, setLastRefreshed] = useState(null);
//   const timerRef = useRef(null);

//   // ── Fetch plant list ───────────────────────────────────────────────────────
//   useEffect(() => {
//     axiosClient
//       .get("/unit/list?page=0&size=999&searchKey=")
//       .then((res) => {
//         const list = Array.isArray(res.data) ? res.data : (res.data?.data ?? []);
//         setPlants(list);
//         // Pre-select assigned plant or first in list
//         if (!selectedPlantId && list.length > 0) {
//           setSelectedPlantId(String(list[0].plant_id));
//         }
//       })
//       .catch((err) => console.error("Failed to load plant list:", err));
//   }, []); // eslint-disable-line

//   // ── Fetch production + inventory data ─────────────────────────────────────
//   const fetchData = useCallback(async () => {
//     if (!selectedPlantId) return;
//     setChartLoading(true);
//     try {
//       const [prodRes, invRes] = await Promise.allSettled([
//         axiosClient.get("/dashboard/production", {
//           params: { report_type: "weekly", plant_id: selectedPlantId },
//         }),
//         axiosClient.get("/dashboard/inventory", {
//           params: { plant_id: selectedPlantId },
//         }),
//       ]);

//       if (prodRes.status === "fulfilled") setProductionData(prodRes.value.data);
//       if (invRes.status === "fulfilled")  setInventoryData(invRes.value.data);

//       setLastRefreshed(new Date());
//     } catch (err) {
//       console.error("PlantDashboard fetchData error:", err);
//     } finally {
//       setChartLoading(false);
//       setLoading(false);
//     }
//   }, [selectedPlantId]);

//   // ── Mount + polling ────────────────────────────────────────────────────────
//   useEffect(() => {
//     fetchData();
//     if (timerRef.current) clearInterval(timerRef.current);
//     timerRef.current = setInterval(fetchData, REFRESH_INTERVAL_MS);
//     return () => clearInterval(timerRef.current);
//   }, [fetchData]);

//   // ── Derived KPIs from today's production data ──────────────────────────────
//   const todayKpis = useMemo(() => {
//     const todayISO = new Date().toISOString().split("T")[0];
//     const arr = productionData?.data ?? [];
//     const todayRows = arr.filter((r) => {
//       const d = r.entry_date ? String(r.entry_date).split("T")[0] : "";
//       return d === todayISO;
//     });

//     return {
//       cylinders_filled: todayRows.reduce((s, r) => s + (Number(r.cylinder_count) || 0), 0),
//       production_kg:    todayRows.reduce((s, r) => s + (Number(r.total_qty_filled) || 0), 0).toFixed(1),
//       carbide_used:     todayRows.reduce((s, r) => s + (Number(r.carbide) || 0), 0).toFixed(1),
//       acetone_used:     todayRows.reduce((s, r) => s + (Number(r.acetone) || 0), 0).toFixed(1),
//     };
//   }, [productionData]);

//   const fullStock  = useMemo(() => (inventoryData?.full?.tgpl ?? 0) + (inventoryData?.full?.customer ?? 0), [inventoryData]);
//   const emptyStock = useMemo(() => (inventoryData?.empty?.tgpl ?? 0) + (inventoryData?.empty?.customer ?? 0), [inventoryData]);

//   // ── 7-day chart data ───────────────────────────────────────────────────────
//   const chartData = useMemo(() => {
//     const last7 = getLast7Days();
//     const arr = productionData?.data ?? [];

//     // Build date → aggregated row map
//     const map = new Map();
//     arr.forEach((r) => {
//       const day = r.entry_date ? String(r.entry_date).split("T")[0] : null;
//       if (!day) return;
//       if (!map.has(day)) map.set(day, { qty: 0, cyls: 0, carbide: 0, acetone: 0 });
//       const o = map.get(day);
//       o.qty     += Number(r.total_qty_filled) || 0;
//       o.cyls    += Number(r.cylinder_count)   || 0;
//       o.carbide += Number(r.carbide)          || 0;
//       o.acetone += Number(r.acetone)          || 0;
//     });

//     return {
//       labels: last7.map(formatDateLabel),
//       datasets: [
//         {
//           label: "Production (kg)",
//           data: last7.map((d) => Math.round((map.get(d)?.qty ?? 0) * 10) / 10),
//           backgroundColor: CHART_COLORS.production,
//           borderWidth: 0,
//           borderRadius: 3,
//         },
//         {
//           label: "Cylinders filled",
//           data: last7.map((d) => map.get(d)?.cyls ?? 0),
//           backgroundColor: CHART_COLORS.cylinders,
//           borderWidth: 0,
//           borderRadius: 3,
//         },
//         {
//           label: "Carbide used (kg)",
//           data: last7.map((d) => Math.round((map.get(d)?.carbide ?? 0) * 10) / 10),
//           backgroundColor: CHART_COLORS.carbide,
//           borderWidth: 0,
//           borderRadius: 3,
//         },
//         {
//           label: "Acetone used (L)",
//           data: last7.map((d) => Math.round((map.get(d)?.acetone ?? 0) * 10) / 10),
//           backgroundColor: CHART_COLORS.err,
//           borderWidth: 0,
//           borderRadius: 3,
//         },
//       ],
//     };
//   }, [productionData]);

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { display: false },
//       tooltip: { mode: "index", intersect: false },
//     },
//     scales: {
//       x: {
//         ticks: { autoSkip: false, maxRotation: 0, font: { size: 11 } },
//         grid: { display: false },
//       },
//       y: {
//         beginAtZero: true,
//         ticks: { font: { size: 11 } },
//         grid: { color: "rgba(0,0,0,0.05)" },
//       },
//     },
//   };

//   const selectedPlantName = useMemo(() => {
//     const p = plants.find((p) => String(p.plant_id) === selectedPlantId);
//     return p?.plant_name ?? "Plant";
//   }, [plants, selectedPlantId]);

//   const kpis = [
//     { label: "Cylinders filled today", value: loading ? null : todayKpis.cylinders_filled, unit: "units",    icon: Inventory2, color: C.accent },
//     { label: "Production kg",          value: loading ? null : todayKpis.production_kg,    unit: "kg today", icon: Scale,      color: C.success },
//     { label: "Carbide used",           value: loading ? null : todayKpis.carbide_used,     unit: "kg today", icon: Science,    color: C.warn },
//     { label: "Acetone used",           value: loading ? null : todayKpis.acetone_used,     unit: "L today",  icon: WaterDrop,  color: C.err },
//     { label: "Full stock",             value: loading ? null : fullStock,                  unit: "cylinders",icon: CheckCircle,color: C.success },
//     { label: "Empty stock",            value: loading ? null : emptyStock,                 unit: "cylinders",icon: DoDisturbOn,color: C.textMuted },
//   ];

//   return (
//     <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, background: C.bg, minHeight: "100vh" }}>

//       {/* ── Header ── */}
//       <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 2.5 }}>
//         <Box>
//           <Typography sx={{ fontSize: 18, fontWeight: 600, color: C.navy }}>Plant Dashboard</Typography>
//           <Typography sx={{ fontSize: 12, color: C.textMuted, mt: 0.3 }}>
//             CYL Tracking System — {selectedPlantName}
//           </Typography>
//         </Box>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//           {/* Plant selector (only if management-level access; plant user sees own plant) */}
//           {plants.length > 1 && (
//             <FormControl size="small" sx={{ minWidth: 150 }}>
//               <InputLabel id="plant-select-label" sx={{ fontSize: 12 }}>Plant</InputLabel>
//               <Select
//                 labelId="plant-select-label"
//                 value={selectedPlantId}
//                 label="Plant"
//                 onChange={(e) => setSelectedPlantId(e.target.value)}
//                 sx={{ fontSize: 12, background: C.card }}
//               >
//                 {plants.map((p) => (
//                   <MenuItem key={p.plant_id} value={String(p.plant_id)} sx={{ fontSize: 12 }}>
//                     {p.plant_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}

//           {lastRefreshed && (
//             <Typography sx={{ fontSize: 11, color: C.textMuted }}>
//               Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
//             </Typography>
//           )}

//           <Chip
//             label="Plant"
//             size="small"
//             icon={<Factory sx={{ fontSize: "13px !important", color: `${C.success} !important` }} />}
//             sx={{ background: "#F0FDF4", color: C.success, border: "0.5px solid #BBF7D0", fontSize: 11, fontWeight: 500 }}
//           />

//           <Box
//             component="span"
//             onClick={fetchData}
//             title="Refresh now"
//             sx={{ cursor: "pointer", color: C.textMuted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}
//           >
//             <Refresh sx={{ fontSize: 18 }} />
//           </Box>
//         </Box>
//       </Box>

//       {/* ── KPI Row ── */}
//       <Grid container spacing={1.5} sx={{ mb: 2 }}>
//         {kpis.map((k) => (
//           <Grid item xs={6} sm={4} md={2} key={k.label}>
//             <KpiCard
//               label={k.label}
//               value={k.value}
//               unit={k.unit}
//               icon={k.icon}
//               accentColor={k.color}
//               loading={loading && k.value === null}
//             />
//           </Grid>
//         ))}
//       </Grid>

//       {/* ── 7-Day Production Chart ── */}
//       <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "10px", background: C.card }}>
//         <CardContent sx={{ p: "14px 16px !important" }}>
//           <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
//               <Factory sx={{ fontSize: 16, color: C.accent }} />
//               <Typography sx={{ fontSize: 13, fontWeight: 600, color: C.navy }}>
//                 7-day production summary — {selectedPlantName}
//               </Typography>
//             </Box>

//             {/* Custom legend */}
//             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
//               {[
//                 { label: "Production (kg)",   color: CHART_COLORS.production },
//                 { label: "Cylinders filled",  color: CHART_COLORS.cylinders },
//                 { label: "Carbide used (kg)", color: CHART_COLORS.carbide },
//                 { label: "Acetone used (L)",  color: CHART_COLORS.acetone },
//               ].map((l) => (
//                 <Box key={l.label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                   <Box sx={{ width: 10, height: 10, borderRadius: "2px", background: l.color, flexShrink: 0 }} />
//                   <Typography sx={{ fontSize: 11, color: C.textMuted }}>{l.label}</Typography>
//                 </Box>
//               ))}
//             </Box>
//           </Box>

//           {chartLoading ? (
//             <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 260 }}>
//               <CircularProgress size={28} sx={{ color: C.accent }} />
//             </Box>
//           ) : (
//             <Box sx={{ position: "relative", width: "100%", height: { xs: 220, sm: 260 } }}>
//               <Bar
//                 data={chartData}
//                 options={chartOptions}
//                 aria-label={`7-day production bar chart for ${selectedPlantName}`}
//               />
//             </Box>
//           )}
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default PlantDashboard;


import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import {
  Box, Grid, Card, CardContent, Typography, CircularProgress,
  Chip, FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import {
  Inventory2, Scale, Science, WaterDrop, CheckCircle,
  DoDisturbOn, Factory, Refresh,Build,
} from "@mui/icons-material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import axiosClient from "../../configs/axios";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// ─── Design tokens ────────────────────────────────────────────────────────────
const C = {
  navy: "#1B3A6B",
  accent: "#2563EB",
  bg: "#F0F4F8",
  card: "#FFFFFF",
  border: "#E2E8F0",
  textMuted: "#64748B",
  success: "#16A34A",
  warn: "#D97706",
  err: "#DC2626",
    purple: "#7C3AED",
  teal: "#0D9488",
  indigo: "#4F46E5",
  rose: "#DB2777",
  amber: "#EA580C",
};

const CHART_COLORS = {
  production: "#2563EB",
  cylinders:  "#16A34A",
  carbide:    "#D97706",
  acetone:    "#DC2626",
};

const REFRESH_INTERVAL_MS = 60_000;

// ─── Helpers ──────────────────────────────────────────────────────────────────

/**
 * Safely extract YYYY-MM-DD from any date format the backend sends:
 *   "2026-05-14"               → "2026-05-14"
 *   "2026-05-14T00:00:00.000Z" → "2026-05-14"
 *   Date object                → "2026-05-14"
 */
const toDateKey = (val) => {
  if (!val) return "";
  return String(val).split("T")[0].split(" ")[0]; // handles ISO and space-separated
};

function getLast7Days() {
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (6 - i));
    return d.toISOString().split("T")[0];
  });
}

function formatDateLabel(iso) {
  // Use UTC to avoid off-by-one from local timezone
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-IN", {
    month: "short", day: "numeric", timeZone: "UTC",
  });
}

// ─── KPI Card ─────────────────────────────────────────────────────────────────
const KpiCard = ({ label, value, unit, icon: Icon, accentColor = C.accent, loading }) => (
  <Card
    elevation={0}
    sx={{
      border: `1px solid ${accentColor}`,
      borderRadius: "10px",
      background: accentColor,
      height: "100%",
    }}
  >
    <CardContent sx={{ p: "12px 14px !important" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.85)", fontWeight: 500, letterSpacing: 0.4, textTransform: "uppercase", mb: 0.5 }}>
            {label}
          </Typography>
          {loading ? (
            <CircularProgress size={18} sx={{ color: "#fff", mt: 0.5 }} />
          ) : (
            <Typography sx={{ fontSize: 24, fontWeight: 700, color: "#fff", lineHeight: 1 }}>
              {value ?? "—"}
            </Typography>
          )}
          {unit && !loading && (
            <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.85)", mt: 0.3 }}>{unit}</Typography>
          )}
        </Box>
        <Icon sx={{ fontSize: 26, color: "#fff", opacity: 0.35, mt: 0.3 }} />
      </Box>
    </CardContent>
  </Card>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const PlantDashboard = () => {

  // ── User info ─────────────────────────────────────────────────────────────
  const userInfo = useMemo(() => {
    try {
      const d = JSON.parse(sessionStorage.getItem("loginUser") || "{}");
      return d?.result?.userInfo || {};
    } catch { return {}; }
  }, []);

  // const assignedPlantId = userInfo?.assigned_plant_id ?? "";
     const assignedPlantId = userInfo?.plant_id ?? "";
  // ── State ─────────────────────────────────────────────────────────────────
  const [plants, setPlants]                 = useState([]);
  const [selectedPlantId, setSelectedPlantId] = useState(assignedPlantId ? String(assignedPlantId) : "");
  const [productionData, setProductionData] = useState(null);
  const [inventoryData, setInventoryData]   = useState(null);
  const [loading, setLoading]               = useState(true);
  const [chartLoading, setChartLoading]     = useState(false);
  const [lastRefreshed, setLastRefreshed]   = useState(null);
  const timerRef = useRef(null);

  // ── Fetch plant list ───────────────────────────────────────────────────────
  useEffect(() => {
    axiosClient
      .get("/unit/list?page=0&size=999&searchKey=")
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : (res.data?.data ?? []);
        setPlants(list);
        if (!selectedPlantId && list.length > 0) {
          setSelectedPlantId(String(list[0].plant_id));
        }
      })
      .catch((err) => console.error("Failed to load plant list:", err));
  }, []); // eslint-disable-line

  // ── Fetch production + inventory ──────────────────────────────────────────
  const fetchData = useCallback(async () => {
    if (!selectedPlantId) return;
    setChartLoading(true);
    try {
      const [prodRes, invRes] = await Promise.allSettled([
        axiosClient.get("/dashboard/production", {
          params: { report_type: "weekly", plant_id: selectedPlantId },
        }),
        axiosClient.get("/dashboard/inventory", {
          params: { plant_id: selectedPlantId },
        }),
      ]);

      if (prodRes.status === "fulfilled") {
        console.log("[PlantDashboard] production raw:", prodRes.value.data); // debug
        setProductionData(prodRes.value.data);
      }
      if (invRes.status === "fulfilled") {
        console.log("[PlantDashboard] inventory raw:", invRes.value.data); // debug
        setInventoryData(invRes.value.data);
      }

      setLastRefreshed(new Date());
    } catch (err) {
      console.error("PlantDashboard fetchData error:", err);
    } finally {
      setChartLoading(false);
      setLoading(false);
    }
  }, [selectedPlantId]);

  // ── Mount + polling ───────────────────────────────────────────────────────
  useEffect(() => {
    fetchData();
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(fetchData, REFRESH_INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, [fetchData]);

  // ── Today's KPIs ──────────────────────────────────────────────────────────
  // FIX: backend sends entry_date as full ISO string e.g. "2026-05-14T00:00:00.000Z"
  // We strip the time part before comparing with today's YYYY-MM-DD
  const todayKpis = useMemo(() => {
    const todayKey = new Date().toISOString().split("T")[0]; // local today "YYYY-MM-DD"
    const arr = productionData?.data ?? [];

    console.log("[PlantDashboard] todayKey:", todayKey, "rows:", arr.length);

    const todayRows = arr.filter((r) => toDateKey(r.entry_date) === todayKey);

    console.log("[PlantDashboard] todayRows matched:", todayRows.length, todayRows);

    return {
      cylinders_filled: todayRows.reduce((s, r) => s + (Number(r.cylinder_count)   || 0), 0),
      production_kg:    todayRows.reduce((s, r) => s + (Number(r.total_qty_filled)  || 0), 0).toFixed(1),
      carbide_used:     todayRows.reduce((s, r) => s + (Number(r.carbide)           || 0), 0).toFixed(1),
      acetone_used:     todayRows.reduce((s, r) => s + (Number(r.acetone)           || 0), 0).toFixed(1),
    };
  }, [productionData]);

  // ── Stock from inventory ──────────────────────────────────────────────────
  const fullStock  = useMemo(() => (inventoryData?.full?.tgpl  ?? 0) + (inventoryData?.full?.customer  ?? 0), [inventoryData]);
  const emptyStock = useMemo(() => (inventoryData?.empty?.tgpl ?? 0) + (inventoryData?.empty?.customer ?? 0), [inventoryData]);

  // ── 7-day chart ───────────────────────────────────────────────────────────
  const chartData = useMemo(() => {
    const last7 = getLast7Days();
    const arr   = productionData?.data ?? [];

    // Build map keyed by YYYY-MM-DD (stripping time from entry_date)
    const map = new Map();
    arr.forEach((r) => {
      const day = toDateKey(r.entry_date);
      if (!day) return;
      if (!map.has(day)) map.set(day, { qty: 0, cyls: 0, carbide: 0, acetone: 0 });
      const o = map.get(day);
      o.qty     += Number(r.total_qty_filled) || 0;
      o.cyls    += Number(r.cylinder_count)   || 0;
      o.carbide += Number(r.carbide)          || 0;
      o.acetone += Number(r.acetone)          || 0;
    });

    return {
      labels: last7.map(formatDateLabel),
      datasets: [
        {
          label: "Production (kg)",
          data: last7.map((d) => +(map.get(d)?.qty     ?? 0).toFixed(1)),
          backgroundColor: CHART_COLORS.production,
          borderWidth: 0, borderRadius: 3,
        },
        {
          label: "Cylinders filled",
          data: last7.map((d) =>   map.get(d)?.cyls    ?? 0),
          backgroundColor: CHART_COLORS.cylinders,
          borderWidth: 0, borderRadius: 3,
        },
        {
          label: "Carbide used (kg)",
          data: last7.map((d) => +(map.get(d)?.carbide ?? 0).toFixed(1)),
          backgroundColor: CHART_COLORS.carbide,
          borderWidth: 0, borderRadius: 3,
        },
        {
          label: "Acetone used (L)",
          data: last7.map((d) => +(map.get(d)?.acetone ?? 0).toFixed(1)),
          backgroundColor: CHART_COLORS.acetone,
          borderWidth: 0, borderRadius: 3,
        },
      ],
    };
  }, [productionData]);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { top: 24 } },
  plugins: {
    legend: { display: false },
    tooltip: { mode: "index", intersect: false },
    datalabels: {
      anchor: "end",
      align: "end",
      offset: 4,
      color: C.navy,
      font: { size: 10, weight: "600" },
      formatter: (value) => (value === 0 ? "" : value),
    },
  },
  scales: {
    x: { ticks: { autoSkip: false, maxRotation: 0, font: { size: 11 } }, grid: { display: false } },
    y: { beginAtZero: true, ticks: { font: { size: 11 } }, grid: { color: "rgba(0,0,0,0.05)" } },
  },
};

  const selectedPlantName = useMemo(() => {
    const p = plants.find((p) => String(p.plant_id) === selectedPlantId);
    return p?.plant_name ?? "Plant";
  }, [plants, selectedPlantId]);

//   const kpis = [
//     { label: "Cylinders Filled", value: loading ? null : todayKpis.cylinders_filled, unit: "units",     icon: Inventory2,  color: C.accent   },
//    { label: "Qty Filled", value: loading ? null : todayKpis.production_kg, unit: "kg", icon: Scale, color: C.success },
//     { label: "Carbide Used",           value: loading ? null : todayKpis.carbide_used,     unit: "kg today",   icon: Science,     color: C.warn     },
//     { label: "Acetone Used",           value: loading ? null : todayKpis.acetone_used,     unit: "L today",    icon: WaterDrop,   color: C.err      },
//     // { label: "Full stock",             value: loading ? null : fullStock,                  unit: "cylinders",  icon: CheckCircle, color: C.success  },
//     // { label: "Empty stock",            value: loading ? null : emptyStock,                 unit: "cylinders",  icon: DoDisturbOn, color: C.textMuted },
//     { label: "Carbide Stock",  value: loading ? null : inventoryData?.carbideStock ?? '—', unit: "kg",  icon: Science,   color: C.warn },
// { label: "Acetone Stock",  value: loading ? null : inventoryData?.acetoneStock ?? '—', unit: "ltr", icon: WaterDrop, color: C.err  },
// { label: "Total Cylinders", value: loading ? null : inventoryData?.totalCylinders ?? '—', unit: "cylinders", icon: Inventory2, color: C.navy },
// { label: "Inspected OK",   value: loading ? null : inventoryData?.inspectedOk ?? '—',   unit: "cylinders", icon: CheckCircle, color: C.success },
// { label: "Insp Due",       value: loading ? null : inventoryData?.inspDue ?? '—',       unit: "cylinders", icon: Build,       color: C.err  },
// { label: "Under Maintenance", value: loading ? null : inventoryData?.maintenance ?? '—', unit: "cylinders", icon: Build,       color: C.warn  },
//   ];

const kpis = [
    { label: "Cylinders Filled", value: loading ? null : todayKpis.cylinders_filled, unit: "units",     icon: Inventory2,  color: C.accent   },
    { label: "Qty Filled", value: loading ? null : todayKpis.production_kg, unit: "kg", icon: Scale, color: C.success },
    { label: "Carbide Used",           value: loading ? null : todayKpis.carbide_used,     unit: "kg today",   icon: Science,     color: C.warn     },
    { label: "Acetone Used",           value: loading ? null : todayKpis.acetone_used,     unit: "L today",    icon: WaterDrop,   color: C.err      },
    { label: "Carbide Stock",  value: loading ? null : inventoryData?.carbideStock ?? '—', unit: "kg",  icon: Science,   color: C.purple },
    { label: "Acetone Stock",  value: loading ? null : inventoryData?.acetoneStock ?? '—', unit: "ltr", icon: WaterDrop, color: C.rose  },
    { label: "Total Cylinders", value: loading ? null : inventoryData?.totalCylinders ?? '—', unit: "cylinders", icon: Inventory2, color: C.navy },
    { label: "Inspected OK",   value: loading ? null : inventoryData?.inspectedOk ?? '—',   unit: "cylinders", icon: CheckCircle, color: C.teal },
    { label: "Insp Due",       value: loading ? null : inventoryData?.inspDue ?? '—',       unit: "cylinders", icon: Build,       color: C.amber  },
    { label: "Under Maintenance", value: loading ? null : inventoryData?.maintenance ?? '—', unit: "cylinders", icon: Build,       color: C.indigo  },
  ];

  return (
    <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, background: C.bg, minHeight: "100vh" }}>

      {/* ── Header ── */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 2.5 }}>
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 600, color: C.navy }}>Plant Dashboard</Typography>
          <Typography sx={{ fontSize: 12, color: C.textMuted, mt: 0.3 }}>
            CYL Tracking System — {selectedPlantName}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          {plants.length > 1 && (
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="plant-select-label" sx={{ fontSize: 12 }}>Plant</InputLabel>
              <Select
                labelId="plant-select-label"
                value={selectedPlantId}
                label="Plant"
                onChange={(e) => setSelectedPlantId(e.target.value)}
                sx={{ fontSize: 12, background: C.card }}
              >
                {plants.map((p) => (
                  <MenuItem key={p.plant_id} value={String(p.plant_id)} sx={{ fontSize: 12 }}>
                    {p.plant_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {lastRefreshed && (
            <Typography sx={{ fontSize: 11, color: C.textMuted }}>
              Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
            </Typography>
          )}

          <Chip
            label="Plant"
            size="small"
            icon={<Factory sx={{ fontSize: "13px !important", color: `${C.success} !important` }} />}
            sx={{ background: "#F0FDF4", color: C.success, border: "0.5px solid #BBF7D0", fontSize: 11, fontWeight: 500 }}
          />

          <Box
            component="span"
            onClick={fetchData}
            title="Refresh now"
            sx={{ cursor: "pointer", color: C.textMuted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}
          >
            <Refresh sx={{ fontSize: 18 }} />
          </Box>
        </Box>
      </Box>

      {/* ── KPI Row ── */}
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        {kpis.map((k) => (
           <Grid item xs={6} sm={4} md={2.4} key={k.label}>
            <KpiCard label={k.label} value={k.value} unit={k.unit} icon={k.icon} accentColor={k.color} loading={loading && k.value === null} />
          </Grid>
        ))}
      </Grid>

      {/* ── 7-Day Production Chart ── */}
      <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "10px", background: C.card }}>
        <CardContent sx={{ p: "14px 16px !important" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <Factory sx={{ fontSize: 16, color: C.accent }} />
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: C.navy }}>
                7-day production summary — {selectedPlantName}
              </Typography>
            </Box>

            {/* Legend */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
              {[
                { label: "Production (kg)",   color: CHART_COLORS.production },
                { label: "Cylinders filled",  color: CHART_COLORS.cylinders },
                { label: "Carbide used (kg)", color: CHART_COLORS.carbide },
                { label: "Acetone used (L)",  color: CHART_COLORS.acetone },
              ].map((l) => (
                <Box key={l.label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: "2px", background: l.color, flexShrink: 0 }} />
                  <Typography sx={{ fontSize: 11, color: C.textMuted }}>{l.label}</Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {chartLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 260 }}>
              <CircularProgress size={28} sx={{ color: C.accent }} />
            </Box>
          ) : (
            <Box sx={{ position: "relative", width: "100%", height: { xs: 220, sm: 260 } }}>
              <Bar data={chartData} options={chartOptions} aria-label={`7-day production bar chart for ${selectedPlantName}`} />
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PlantDashboard;